import React, { useState } from 'react'
import "./faq.css";
import { FaChevronDown } from "react-icons/fa";
import { IconContext } from "react-icons";
import { FaChevronUp } from "react-icons/fa";

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const accordionData = [
        {
          question: "What is Akasha?",
          answer:
            "Akasha is a layer zero blockchain technology that connects all blockchains together, allowing them to communicate and share data seamlessly. It acts as the foundation for a fully connected blockchain ecosystem.",
        },
        {
          question: "What makes Akasha different from other blockchains?",
          answer: "Unlike traditional blockchains that operate independently, Akasha enables interoperability, meaning different blockchains can work together without limitations.",
        },
        {
          question: "How does Akasha help first-time crypto users?",
          answer: "Akasha simplifies the crypto experience by making it easier to move assets between blockchains, reducing transaction fees and improving security. It removes many of the barriers that make crypto confusing for new users.",
        },
        {
          question: "Is Akasha secure?",
          answer: "Yes! Akasha is built with advanced security measures to ensure safe transactions and protect users from hacks and fraud.",
        },
        {
          question: "Is Akasha decentralized?",
          answer: "Yes, Akasha is designed to be fully decentralized, ensuring no single entity controls the network.",
        },
        {
          question: "How can I get involved in the Akasha community?",
          answer: "Join our online communities, participate in discussions and stay updated on new developments through our official channels.",
        },
      ];
      const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    return (
        <div className='faq-sec'>
            <div className='faq-head'>
                <div className='faq-head-text'>Frequently Asked Questions</div></div>

                <div className='faq-accordion'>
                <div className="accordion-container">
      {accordionData.map((item, index) => (
        <div
          key={index}
          className={`accordion-item ${openIndex === index ? "open" : ""}`}
          onClick={() => toggleAccordion(index)}
        >
          <div className="accordion-header">
            <div>{item.question}</div>
            {openIndex === index ? 
            <IconContext.Provider value={{ color: "#000", className: "global-class-name" }}>
            <div>
            <FaChevronUp />
            </div>
          </IconContext.Provider> :
          <IconContext.Provider value={{ color: "#000", className: "global-class-name" }}>
          <div>
          <FaChevronDown />
          </div>
        </IconContext.Provider>
        
        }
            {/* <span className="icon">{openIndex === index ? "▲" : "▼"}</span> */}
          </div>
          {openIndex === index && <div className="accordion-content">{item.answer}</div>}
        </div>
      ))}
    </div>
                </div>
        </div>
    )
}

export default FAQSection;
